import { getValue } from '@Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import SubscriptionCard from '../SubscriptionCard/SubscriptionCard';
import { SubscriptionsCardContainer } from './SubscriptionsCardGroup.styles';

const SubscriptionsCardGroup = () => {
	const products = useSelector(getValue).products.list;
	return (
		<SubscriptionsCardContainer>
			{products.map(product => {
				return (
					<SubscriptionCard
						key={product.name}
						product={product}
						hasSecondaryFooter
						numberOfSubscriptionsUsed={
							product.numberOfEntitlementsUsed || 0
						}
					/>
				);
			})}
		</SubscriptionsCardContainer>
	);
};

export default SubscriptionsCardGroup;
